import { motion } from "framer-motion";
import { scrollToId, LOGO_URL } from "../lib/content";

const links = [
  { label: "LEARN", id: "learn" },
  { label: "HOST", id: "host" },
  { label: "FAQ", id: "faq" },
];

export const Nav = () => (
  <div className="fixed top-5 left-0 right-0 z-[100] flex justify-center pointer-events-none px-3">
    <motion.nav
      initial={{ opacity: 0, y: -16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="pointer-events-auto flex items-center gap-1 rounded-full glass-panel px-2 py-1.5"
      data-testid="floating-nav"
      style={{ background: "rgba(255,255,255,0.75)" }}
    >
    <div className="hidden sm:flex items-center justify-center bg-white rounded-full w-8 h-8 overflow-hidden shrink-0 ml-0.5" data-testid="nav-logo">
      <img src={LOGO_URL} alt="Yes We Can Lending" className="w-7 h-7 object-contain" />
    </div>
    {links.map((l) => (
      <button
        key={l.id}
        data-testid={`nav-link-${l.id}`}
        onClick={() => scrollToId(l.id)}
        className="font-mono-c text-[10px] md:text-[11px] tracking-[0.14em] md:tracking-[0.18em] px-2.5 md:px-3.5 py-2 text-black/60 hover:text-black transition-colors duration-200"
      >
        {l.label}
      </button>
    ))}
    <button
      data-testid="nav-register-cta"
      onClick={() => scrollToId("register")}
      className="btn-accent rounded-full text-[10px] md:text-[11px] px-3.5 md:px-5 py-2"
    >
      REGISTER ↗
    </button>
  </motion.nav>
  </div>
);
